import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import { useContext } from "react";
import { contractEntityProfilePath } from "@app/projects/network-assessment/provider-hub/providerHubProfilePaths";

export const useContractEntityLink = () => {
  const projectContext = useContext(CountyProjectContext);

  return (contractEntityId: number | string): string => `${window.customUIBaseUrl}${contractEntityProfilePath(projectContext.project.projectId, projectContext.runConfiguration.projectRunConfigurationId, Number(contractEntityId))}`;
}
